import types from './actionTypes';
import { addOrReplaceObjectInArray } from '../../helpers/reducerHelper';

const initialState = {
  loading: false,
  subscriptions: [],
  startDate: null,
  endDate: null,
  success: '',
  error: '',
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_SUBSCRIPTION_STATE:
      return initialState;
    case types.RESET_SUBSCRIPTION_MESSAGE:
      return {
        ...state,
        error: '',
        success: '',
      };
    case types.CREATE_SUBSCRIPTION.REQUEST:
    case types.UPDATE_SUBSCRIPTION.REQUEST:
    case types.CANCEL_SUBSCRIPTION.REQUEST:
    case types.FETCH_SUBSCRIPTIONS.REQUEST:
    case types.FETCH_SUBSCRIPTIONS_BY_USER.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_SUBSCRIPTION.SUCCESS:
    case types.UPDATE_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        subscriptions: [...state.subscriptions, action.subscription],
      };
    case types.FETCH_SUBSCRIPTIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        subscriptions: action.subscriptions,
        startDate: action.startDate,
        endDate: action.endDate,
      };
    case types.FETCH_SUBSCRIPTIONS_BY_USER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        subscriptions: action.subscriptions,
      };
    case types.CANCEL_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.message,
        subscriptions: addOrReplaceObjectInArray(
          state.subscriptions,
          action.subscription,
          'id',
          'merge',
        ),
      };
    case types.CREATE_SUBSCRIPTION.FAILURE:
    case types.UPDATE_SUBSCRIPTION.FAILURE:
    case types.CANCEL_SUBSCRIPTION.FAILURE:
    case types.FETCH_SUBSCRIPTIONS.FAILURE:
    case types.FETCH_SUBSCRIPTIONS_BY_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
